<template>
  <div :class="activeSystem">
    <div id="wt-layout-single" v-if="typeLayout===1">
      <wtMain></wtMain>
    </div>
    <div id="wt-layout-no-sidebar" v-if="typeLayout===2">
      <wtHeader></wtHeader>
      <wtMain></wtMain>
      <wtFooter></wtFooter>
    </div>
    <div id="wt-layout-sidebar" v-if="typeLayout===3">
      <wtHeader></wtHeader>
      <wtMain></wtMain>
      <wtSidebar class="wt-slide"></wtSidebar>
      <wtFooter></wtFooter>
    </div>
    <div id="wt-layout-sidebar-min" v-if="typeLayout===4">
      <wtHeader></wtHeader>
      <wtMain></wtMain>
      <wtSidebar></wtSidebar>
      <wtFooter></wtFooter>
    </div>
  </div>
</template>

<script>
import wtHeader from "@/components/layout/header/wtHeader.vue";
import wtMain from "@/components/layout/main/wtMain.vue";
import wtSidebar from "@/components/layout/sidebar/wtSidebar.vue";
import wtFooter from "@/components/layout/footer/wtFooter.vue";

export default {
  name: "LayoutPage",
  components: {
    wtHeader,
    wtMain,
    wtSidebar,
    wtFooter
  },
  computed: {
    typeLayout() {
      return this.$store.state.layout.typeLayout;
    },
    activeSystem() {
      return this.$store.state.activeSystem;
    }
  },
  data() {
    return {};
  }
};
</script>


